module.exports = __webpack_public_path__ + "img/news-2.5d3b4ec2.jpg";